"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const preact_1 = require("preact");
const glamor_1 = require("glamor");
const glamor_tachyons_1 = require("glamor-tachyons");
class Tabs extends preact_1.Component {
    render() {
        const { tabNames, activeTab, handleClick } = this.props;
        const tabs = tabNames.length > 0 ?
            tabNames.map((name) => (preact_1.h(Tab, { key: name, id: name, handleClick: handleClick, isActive: name === activeTab }, name)))
            : null;
        const tabStyle = glamor_1.css(Object.assign({ overflowX: 'scroll', overflowY: 'hidden', whiteSpace: 'nowrap' }, glamor_tachyons_1.tachyons('bb b--light-gray pb3 mt3')));
        return (preact_1.h("div", { className: `${tabStyle} visor-tabs` }, tabs));
    }
}
exports.Tabs = Tabs;
class Tab extends preact_1.Component {
    render() {
        const { children, isActive, handleClick, id } = this.props;
        const tabStyle = glamor_1.css(Object.assign({ borderBottomColor: isActive ? '#357EDD' : '#AAAAAA', borderBottomWidth: '1px', borderBottomStyle: 'solid', cursor: 'pointer', ':hover': {
                color: '#357EDD'
            }, display: 'inline-block' }, glamor_tachyons_1.tachyons('b f5 mr3 pa2')));
        return (preact_1.h("a", { className: `${tabStyle} tf-tab`, "data-isactive": isActive, onClick: () => handleClick(id) }, children));
    }
}
//# sourceMappingURL=tabs.js.map